import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Input from "../../../../components/inputs/input";
import { getFormFieldConfig } from "./utils/form-field-components";

const useStyles = makeStyles({
	formField: {
		width: "100%"
	}
});

const FormField = ({
	field,
	value,
	onChange,
	onBlur,
	error
}) => {
	const classes = useStyles();

	const fieldClassName = [
		classes.formField,
		error ? "form-field__input--error" : ""
	].filter(Boolean).join(" ");

	const handleFieldChange = eventOrValue => {
		const rawValue =
			field.type === "date"
				? eventOrValue
				: eventOrValue.target.value;

		const finalValue = field.onChange
			? field.onChange(rawValue)
			: rawValue;

		onChange(field.name, finalValue);
	};

	const handleFieldBlur = () => {
		if (typeof onBlur !== "function") {
			return;
		}

		onBlur(field.name);
	};

	const fieldConfig = getFormFieldConfig(field.type);

	if (fieldConfig) {
		const FieldComponent = fieldConfig.component;

		const componentProps = fieldConfig.getProps
			? fieldConfig.getProps({
				field,
				value,
				onChange,
				onBlur,
				error,
				fieldClassName,
				handleFieldChange,
				handleFieldBlur
			})
			: {
				field,
				value,
				onChange,
				onBlur: handleFieldBlur,
				error,
				className: fieldClassName
			};

		return <FieldComponent {...componentProps} />;
	}

	return (
		<Input
			className={fieldClassName}
			name={field.name}
			label={field.label}
			type={field.type}
			value={value ?? ""}
			placeholder={field.placeholder}
			onChange={handleFieldChange}
			onBlur={handleFieldBlur}
			mask={field.mask}
			guide={field.guide}
			disabled={field.disabled}
			min={field.min}
			max={field.max}
			step={field.step}
			maxlength={field.maxLength}
			width="100%"
		/>
	);
};

export default FormField;